import artifact from '$houdini/artifacts/DeleteGroup'
import { MutationStore } from '../runtime/stores/mutation'

export class DeleteGroupStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
